/**
 * Transforms the string to its boolean equivalent.
 *
 * @export
 * @param {string} boolVal
 * @return {boolean}
 */
export default function parseBool(boolVal) {
  return JSON.parse(boolVal);
}
